import { EmailBlockDefinition } from "../types";

import { LuQuote } from "react-icons/lu";

import { quoteEmailRenderer } from "./email-renderer";
import { QuoteTiptapView } from "./tiptap-view";

export interface QuoteAttrs extends Record<string, unknown> {
  header: string;
  bodyHtml: string;
}

export const quoteBlock: EmailBlockDefinition<QuoteAttrs> = {
  name: "emailQuote",
  label: "Quote",
  icon: LuQuote,
  category: "content",
  schema: {
    attrs: {
      header: { default: "" },
      bodyHtml: { default: "" },
    },
    content: undefined,
    group: "emailBlock",
    draggable: false,
    isolating: true,
  },
  tiptapComponent: QuoteTiptapView,
  emailRenderer: quoteEmailRenderer,
};
